import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
// import extend from 'lodash/extend';
import chunk from 'lodash/chunk';
import { withRouter } from 'react-router';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';

/*
import Ad from '../../../components/ad/ad';
import Slug from '../../../components/slug/slug';
import MCPSection from '../../../components/mcp_section/mcp_section';
import FeatureFeed from '../../../components/feature_feed/feature_feed';
import { isAdvertorial } from '../../../components/advertorial/advertorial';
*/

// eslint-disable-next-line react/prefer-stateless-function
class MicSectorYear extends Component {
  render() {
    if (this.props.micSectorYearPage.error || this.props.status === 404) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.micSectorYearPage.isLoading) {
      return (
        <section className="most-creative-people-page">
          <article className="most-creative-people-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    /*
    const adData = get(this.props, 'micSectorYearPage.ads');
    const combinedAdModel = extend({},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );

    const year = get(this.props, 'match.params.year');
    const tags = get(this.props, 'tagAllFeed.posts[0].tags');
    const advertorial = isAdvertorial(tags);
    const pgTitle = `The Most Creative People In Business ${year}`;
    const sectionTitle = `Meet The 100 Most Creative People in Business ${year}`;
    const mcpList = get(this.props, 'micSector');
    const mcpSections = mcpList.map((people, index) => ({ id: `section-${index + 1}`, people }));
    const featuredFeed = get(this.props, 'micSectorFeaturedFeed');
    const scrollingModule = get(this.props, 'micSectorScrollingModule');

    const uri = encodeURIComponent(`https://www.fastmic.com/most-creative-people/${year}`);
    */
    return <section><h2>WIP</h2></section>;
  }
}

/* eslint-disable */
function mapStateToProps(state = {}) {
  const micData = chunk(get(state, 'micSector.data.rows'), 10);
  return {
    config: state.config || {},
    status: state.status.code,
    micSectorYearPage: get(state, 'micSectorYearPage') || { error: true },
    micSector: micData || { error: true },
    micSectorFeaturedFeed: get(state, 'micSectorFeaturedFeed') || { error: true },
    micSectorScrollingModule: get(state, 'micSectorScrollingModule.data') || { error: true }
  };
}

MicSectorYear.propTypes = {
  status: PropTypes.number,
  micSectorYearPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }),
  micSector: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({

      })
    )
  ),
  micSectorFeaturedFeed: PropTypes.shape({}),
  micSectorScrollingModule: PropTypes.shape({})
};

MicSectorYear.defaultProps = {

};
/* eslint-enable */

export default withRouter(connect(mapStateToProps)(MicSectorYear));



// WEBPACK FOOTER //
// ./src/views/containers/pages/mic_sector_year_page/mic_sector_year_page.js